// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TokenExpirationProvider } from './contexts/TokenExpirationContext';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import SoftSkills from './pages/SoftSkills';
import HardSkills from './pages/HardSkills';
import AnalyzeCV from './pages/AnalyzeCV'; 
import PrivateRoute from './components/PrivateRoute';
import SoftSkillsResults from './pages/SoftSkillsResults';
import HardSkillsResults from './pages/HardSkillsResults';
import InterviewResults from './pages/InterviewResults';
import ViewCV from './pages/ViewCV';
import AddictionDetection from './pages/AddictionDetection';
import AddictionDetectionResults from './pages/AddictionDetectionResults';
import VocationalSecundary from './pages/VocationalSecundary';
import VocationalSecundaryResults from './pages/VocationalSecundaryResults';
import VocationalUniversity from './pages/VocationalUniversity';
import VocationalUniversityResults from './pages/VocationalUniversityResults';
import Bullying from './pages/Bullying';
import BullyingResults from './pages/BullyingResults';
import GeneralOverview from './pages/GeneralOverview';
import GeneratedCV from './pages/GeneratedCV';
import AdminDashboard from './pages/AdminDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DemographicSurvey from './pages/DemographicSurvey';
import DemographicResults from './pages/DemographicResults';

function App() {
  return (
    <Router>
      <TokenExpirationProvider>
        <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/analyze-cv"
          element={
            <PrivateRoute>
              <AnalyzeCV />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/general-overview"
          element={
            <PrivateRoute>
              <GeneralOverview />
            </PrivateRoute>
          }
        />
        <Route
          path="/soft-skills"
          element={
            <PrivateRoute>
              <SoftSkills />
            </PrivateRoute>
          }
        />
        <Route
          path="/hard-skills"
          element={
            <PrivateRoute>
              <HardSkills />
            </PrivateRoute>
          }
         />
         <Route
          path="/interview-results"
          element={
            <PrivateRoute>
              <InterviewResults />
            </PrivateRoute>
          }
         />
         <Route
          path="/soft-skills-results"
          element={
            <PrivateRoute>
              <SoftSkillsResults />
            </PrivateRoute>
          }
         />
         <Route
          path="/vocational"
          element={
            <PrivateRoute>
              <VocationalSecundary />
            </PrivateRoute>
          }
          />
          <Route
          path="/vocational-results"
          element={
            <PrivateRoute>
              <VocationalSecundaryResults/>
            </PrivateRoute>
          }
          />
          <Route
          path="/vocationalUniversity"
          element={
            <PrivateRoute>
              <VocationalUniversity />
            </PrivateRoute>
          }
          />
          <Route
          path="/vocationalUniversity-results"
          element={
            <PrivateRoute>
              <VocationalUniversityResults/>
            </PrivateRoute>
          }
          />
          <Route
          path="/Bullying"
          element={
            <PrivateRoute>
              <Bullying />
            </PrivateRoute>
          }
          />
          <Route
          path="/Bullying-results"
          element={
            <PrivateRoute>
              <BullyingResults/>
            </PrivateRoute>
          }
          />
         <Route
          path="/addiction-detection"
          element={
            <PrivateRoute>
              <AddictionDetection />
            </PrivateRoute>
          }
          />
         <Route
          path="/addiction-detection-results"
          element={
            <PrivateRoute>
              <AddictionDetectionResults />
            </PrivateRoute>
          }
         />
         <Route
          path="/hard-skills-results"
          element={
            <PrivateRoute>
              <HardSkillsResults />
            </PrivateRoute>
          }
         />
         <Route
          path="/view-cv"
          element={
            <PrivateRoute>
              <ViewCV />
            </PrivateRoute>
          }
         />
         <Route
          path="/generated-cv"
          element={
            <PrivateRoute>
              <GeneratedCV />
            </PrivateRoute>
          }
         />
         <Route
          path="/admin-dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
         />
         <Route
          path="/demographic-survey"
          element={
            <PrivateRoute>
              <DemographicSurvey />
            </PrivateRoute>
          }
         />
         <Route
          path="/demographic-results"
          element={
            <PrivateRoute>
              <DemographicResults />
            </PrivateRoute>
          }
         />
        </Routes>
      </TokenExpirationProvider>
    </Router>
  );
}

export default App;
